import { ReactElement, useEffect, useState } from 'react';
import { useWebSocketLazy } from '~/helpers/wsConnection';
import { DamScheduleSummary } from '.';
import { DamReferenceEcoMode } from '../EcoMode';
import { AssetsSummaryContainer, ScheduleSummaryContainer } from './styles';

interface DamAssetsScheduleSummaryProps {
  damId: string;
}

function beforeWsClose(wsConn) {
  wsConn.send({ type: 'unsubscribeStatus' });
}

export function DamAssetsScheduleSummary({
  damId,
}: Readonly<DamAssetsScheduleSummaryProps>): ReactElement {
  const [status, setStatus] = useState('OFFLINE');
  const wsl = useWebSocketLazy();

  function onWsOpen(wsConn) {
    wsConn.send({ type: 'subscribeStatus', data: { dam_id: damId } });
  }

  function onWsMessage(payload) {
    if (!payload) return;
    if (payload.type !== 'damStatus') return;
    if (payload.dev_id !== damId) return;
    if (payload.data.status) setStatus(payload.data.status);
  }

  useEffect(() => {
    if (damId) {
      wsl.start(onWsOpen, onWsMessage, beforeWsClose);
    }
  }, []);

  return (
    <AssetsSummaryContainer>
      <ScheduleSummaryContainer>
        <DamScheduleSummary damId={damId} status={status} />
      </ScheduleSummaryContainer>
      <div>
        <DamReferenceEcoMode damId={damId} />
      </div>
    </AssetsSummaryContainer>
  );
}
